/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorissueinvalidprice4Inputs */

const en_menueditorissueinvalidprice4 = /** @type {(inputs: Menueditorissueinvalidprice4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A price cannot be read. Write it like 8.50.`)
};

const de_menueditorissueinvalidprice4 = /** @type {(inputs: Menueditorissueinvalidprice4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Preis ist nicht lesbar. Schreib ihn wie 8,50.`)
};

/**
* | output |
* | --- |
* | "A price cannot be read. Write it like 8.50." |
*
* @param {Menueditorissueinvalidprice4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorissueinvalidprice4 = /** @type {((inputs?: Menueditorissueinvalidprice4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorissueinvalidprice4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorissueinvalidprice4(inputs)
	return de_menueditorissueinvalidprice4(inputs)
});
export { menueditorissueinvalidprice4 as "menuEditorIssueInvalidPrice" }